export default {
  userData(state) {
    return state.userData || {};
  },
  isImpersonator(_state, getters) {
    if (!getters.userData) return false;
    const { Impersonator } = getters.userData;
    return Impersonator;
  },
  userPermissions(_state, getters) {
    const permissions = getters?.userData?.permissions;
    if (!getters.userData || !permissions) return [];
    if (Array.isArray(permissions)) return permissions;

    return [permissions];
  },
  isClient(_state, getters) {
    if (!getters.userData) return false;
    const { ClientId } = getters.userData;
    return Boolean(ClientId);
  },
  clientFirstName(state) {
    return state.userInfo && state.userInfo.firstName;
  },
  clientDomain(state) {
    return state.clientInfo && state.clientInfo.domain;
  },
  clientName(state) {
    return state.clientInfo && state.clientInfo.name;
  },
  hasClientFeature(state) {
    return (feature) => state.userInfo && state.userInfo.features.includes(feature);
  },
  sidenavCollapsed(state) { return state.sidenavCollapsed; },
  userInfo(state) { return state.userInfo; },
  clientInfo(state) { return state.clientInfo; },
  showTutorial(state) { return state.showTutorial; },
  theme(state) { return state.theme; },
  isLightTheme(state) { return state.theme === 'light-theme'; },
};
